import axios from 'axios';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

export default {
  namespaced: true,
  state: {
    Tasks: [],
  },
  mutations: {
    updateTask(state, tasks) {
      state.Tasks = tasks;
    },
  },
  actions: {
    getTasks(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/tasks/',
          method: 'get',
        })
          .then((response) => {
            context.commit('updateTask', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('updateTask', []);
            reject(error.response.data);
          });
      });
    },
    postNewTask(context, formData) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/tasks/add/',
          method: 'post',
          data: formData,
        })
          .then((response) => {
            console.log('Post New Task:', response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log('Post New Task Error:', error);
            reject(error);
          });
      });
    },

    async updateTaskEntry(context, taskEntry) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/tasks/update/',
          method: 'put',
          data: taskEntry,
        })
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
  },
  getters: {
    getTasks(state) {
      return state.Tasks;
    },
  },
};
